import { memo } from 'react';
import { cn } from '@divlab/divanui';

import styles from './FurnitureSizes.module.css';

import type { FC, HTMLAttributes } from 'react';
import type { AdditionalImage } from '@Pages/PageProduct';

interface FurnitureSizesProps extends HTMLAttributes<HTMLDivElement> {
  images: AdditionalImage[];
}

const FurnitureSizes: FC<FurnitureSizesProps> = (props) => {
  const { className, images, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.grid, className)}>
      {images.map((image) => (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          className={styles.image}
          key={image.src}
          src={image.src}
          style={{ maxWidth: image.width, maxHeight: image.height }}
          alt=''
        />
      ))}
    </div>
  );
};

export default memo(FurnitureSizes);
